import {
  QV_SESSION_LOGIN_ID_STORAGE_KEY,
  QV_LOGIN_ID_STORAGE_KEY_LEGACY,
} from "../Constants/Config";

/**
 * Resolves session login id from create_session: prefer `employee_id`, else `data.id` or top-level `id`.
 * Matches runtime resolution in getAuthDetails (cookiesHelper).
 */
function extractCreateSessionUserId(payload) {
  if (!payload || typeof payload !== "object") return null;
  if (payload.employee_id != null && String(payload.employee_id).trim() !== "") {
    return String(payload.employee_id).trim();
  }
  const inner = payload.data;
  if (inner && typeof inner === "object" && !Array.isArray(inner)) {
    if (inner.id != null && String(inner.id).trim() !== "") {
      return String(inner.id).trim();
    }
  }
  if (payload.id != null && String(payload.id).trim() !== "") {
    return String(payload.id).trim();
  }
  return null;
}

/**
 * Persists session login `id` from create_session. Call only from full login (`handleUserType`),
 * not from store-switch create_session (`handleGetStoreRecord`).
 */
export function persistSessionLoginIdFromCreateSessionResponse(responseData) {
  const id = extractCreateSessionUserId(responseData);
  if (!id) return;
  try {
    localStorage.setItem(QV_SESSION_LOGIN_ID_STORAGE_KEY, id);
  } catch (e) {
    // quota / private mode
  }
}

export function getPersistedSessionLoginId() {
  try {
    let v = localStorage.getItem(QV_SESSION_LOGIN_ID_STORAGE_KEY);
    if (v == null || String(v).trim() === "") {
      v = localStorage.getItem(QV_LOGIN_ID_STORAGE_KEY_LEGACY);
    }
    return v != null && String(v).trim() !== "" ? String(v).trim() : null;
  } catch {
    return null;
  }
}

export function clearPersistedSessionLoginId() {
  try {
    localStorage.removeItem(QV_SESSION_LOGIN_ID_STORAGE_KEY);
    localStorage.removeItem(QV_LOGIN_ID_STORAGE_KEY_LEGACY);
  } catch (e) {
    // ignore
  }
}
